module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../~/vue2-google-maps/~/core-js/library/modules/$.html.js
// module id = 1114
// module chunks = 0